<div class="panel-luminary">
  <div class="panel-luminary__content custom-scrollbar" tabindex="0">
    <div class="panel-luminary__indicators">
      <div class="indicator-card indicator-card--on">
        <div class="indicator-card__icon">
          <sit-icon [icon]="Icon.luminary_green" [sizeClass]="'icon-size-32'" alt="Conectadas"></sit-icon>
        </div>
        <span class="indicator-card__value">{{ totalConectadas }}</span>
      </div>
      <div class="indicator-card indicator-card--off">
        <div class="indicator-card__icon">
          <sit-icon [icon]="Icon.luminary_blue" [sizeClass]="'icon-size-32'" alt="Desconectadas"></sit-icon>
        </div>
        <span class="indicator-card__value">{{ totalDesconectadas }}</span>
      </div>
      <div class="indicator-card indicator-card--unknown">
        <div class="indicator-card__icon">
          <sit-icon [icon]="Icon.luminary_grey" [sizeClass]="'icon-size-32'" alt="Desconocidas"></sit-icon>
        </div>
        <span class="indicator-card__value">{{ totalDesconocidas }}</span>
      </div>
    </div>

    <div class="panel-luminary__search">
      <input
        type="text"
        class="panel-luminary__search-input"
        placeholder="Buscar"
        [(ngModel)]="searchTerm"
      />
      <sit-icon [icon]="Icon.lupa" [sizeClass]="'icon-size-20'" alt="Buscar"></sit-icon>
    </div>

    <div class="panel-luminary__cards">
      <div
        *ngFor="let card of filteredCards"
        class="luminary-card"
        (click)="openModal(card)"
      >
        <div class="luminary-card__header">
          <span class="luminary-card__id">{{ card.assetId }}</span>
          <span class="luminary-card__title">Luminaria {{ card.lampType }}</span>
        </div>

        <div class="luminary-card__row">
          <sit-icon [icon]="Icon.settings_white" [sizeClass]="'icon-size-24'" alt="Operador"></sit-icon>
          <span>{{ card.operator || 'No registra' }}</span>
        </div>
        <div class="luminary-card__row">
          <sit-icon [icon]="Icon.dimmer_white" [sizeClass]="'icon-size-24'" alt="Dimmer"></sit-icon>
          <span>{{ card.dimmingStatus || 'No registra' }}</span>
        </div>
        <div class="luminary-card__row">
          <sit-icon [icon]="Icon.power_white" [sizeClass]="'icon-size-24'" alt="Estado"></sit-icon>
          <span>{{ card.status || 'No registra' }}</span>
        </div>
      </div>

      <div *ngIf="filteredCards.length === 0" class="panel-luminary__empty">
        No hay luminarias para mostrar.
      </div>
    </div>
  </div>
</div>

